import axios from 'axios';
import { getSpareminToken } from 'config/configure';
import {
  CreateAuthUrlResponse,
  GetSocialAuthStatusRequest,
  GetSocialAuthStatusResponse,
  SocialPlatform,
} from './types';
import { createApiAuthUrl, createGetAuthStatusUrl } from './utils';

export async function generateAuthUrl(
  platform: SocialPlatform,
): Promise<CreateAuthUrlResponse> {
  const url = createApiAuthUrl(platform);
  const { data } = await axios.get<CreateAuthUrlResponse>(url, {
    withCredentials: true,
  });
  return data;
}

export async function getSocialAuthStatus(
  config: GetSocialAuthStatusRequest,
): Promise<GetSocialAuthStatusResponse> {
  const spareminToken = config.spareminToken ?? getSpareminToken();
  const authHeader = !spareminToken
    ? undefined
    : { Authorization: `Bearer ${spareminToken}` };

  const url = createGetAuthStatusUrl(config);

  const { data } = await axios.get<GetSocialAuthStatusResponse>(url, {
    headers: authHeader,
    withCredentials: true,
  });

  return data;
}
